export default {
  appFormStarted: 'The date when the applicant started to fill out an application form. This does not necessarily mean the application was completed and submitted.',
  selfReportedCreditScore: 'The credit score the applicant provided in the application form.',
  requestedAmount: 'The loan amount the applicant requested in the application form.',
  appFormComplete: 'If there’s a check mark, the applicant has completed and submitted the application.',
  receivedOffers: `Offers that were shown to the applicant after they submitted
  their application. The brackets indicate the total number of the provided
  offers and the maximum amount.
  <ul>
    <li><b>Selected</b> label shows whether the applicant selected any of the received offers and continued the application process.</li>
    <li><b>Qualified</b> label shows that in the application process the HELOC lender further collected information about the applicant.</li>
    <li><b>HELOC</b> stands for home equity line of credit.</li>
    <li><b>“–“</b> (Dash) – the application was not submitted or an error was received when submitting the application.</li>
  </ul>
  `,
  creditDecision: `The status of the final application submitted to the lender.
  <ul>
    <li><b>APPROVED</b> – At least one of the submitted applications was approved by the lender.</li>
    <li><b>EXPIRED</b> – There is no information received for any of the submitted applications with Selected label within the 50-day waiting period. Applications with <b>Qualified</b> label cannot get the <b>EXPIRED</b> status. <b>EXPIRED</b> status can change to <b>APPROVED</b> if information was received after the waiting period.</li>
    <li><b>“–“</b> (Dash) – There is no information received for any of the submitted applications, but the waiting period is not over yet. Dash is also shown if there were <b>No Offers</b> received on the application or the last received status of the application was <b>Qualified</b>. This status can subsequently change to <b>EXPIRED</b> or <b>APPROVED</b>.</li>
  </ul>
  `,
  funded: `Shows whether the applicant received funds and the amount of received funds
  <ul>
    <li><b>Loans</b> – The applicant was approved for a loan, which means it can be any type of loan, including personal loan, short-term loan, secured loan, etc.</li>
    <li><b>0% funding</b> – The applicant was approved for a credit card. The limit amount is hidden in accordance with the current legislation.</li>
    <li><b>“–“</b> (Dash) – No application was funded.</li>
  </ul>
  `,
  fundedDate: 'The date when funds were received by the applicant.',
};
